import React, {useEffect} from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Divider,
  Typography
} from '@material-ui/core';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  chartContainer: {
    position: 'relative',
    height: '300px'
  },
  stats: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  device: {
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  deviceIcon: {
    color: theme.palette.icon
  }
}));

const UsersByDevice = props => {
  const { className, agrupar, total, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

  const  data = {
    datasets: [
      {
        data: [63, 15, 22],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.error.main,
          theme.palette.warning.main
        ],
        borderWidth: 8,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
    labels: ['Tecnología', 'Sistema de información', 'Otros']
  };
  useEffect(() => {
    data.datasets.data = [];
    agrupar.forEach(element => {
      data.datasets.push({
          data: (element.cantidad/total)*100
      })
    });
  }, []);
  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.white,
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary
    }
  };


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <IconButton size="small">
            <RefreshIcon />
          </IconButton>
        }
        title="Porcentaje por categoria de requerimientos"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          <Doughnut
            data={data}
            options={options}
          />
        </div>
        <div className={classes.stats}>
          {agrupar.map(device => (
            <div
              className={classes.device}
              key={device.tipo}
            >
              {device.tipo === "Tecnología" ? <span className={classes.deviceIcon}><LaptopMacIcon /></span>: null}
              {device.tipo === "Sistema de información" ? <span className={classes.deviceIcon}><TabletMacIcon /></span>: null}
              {device.tipo === "Otros" ? <span className={classes.deviceIcon}><PhoneIphoneIcon /></span>: null}
              <Typography variant="body1">{device.tipo}</Typography>
              <Typography
                style={{ color: theme.palette.primary.main }}
                variant="h2"
              >
                {((device.cantidad/total)*100).toFixed(2)}%
              </Typography>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

UsersByDevice.propTypes = {
  className: PropTypes.string,
  agrupar: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired
};

export default UsersByDevice;
